import { render, staticRenderFns } from "./FavoriteInstaller.vue?vue&type=template&id=377e55da&scoped=true&"
import script from "./FavoriteInstaller.vue?vue&type=script&lang=js&"
export * from "./FavoriteInstaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e55da",
  null
  
)

export default component.exports